import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { ERequestStatus } from 'src/api/enumRequest';

import { selectStatusCreateQuote, selectErrorCreateQuote } from 'src/store/slice/quote/state';
import { selectStatusCreatePaymentAddress, selectErrorCreatePaymentAddress } from 'src/store/slice/payment/state';
import { selectStatusGetMarketPrice, selectErrorGetMarketPrice } from 'src/store/slice/marketPrice/state';

const useErrors = () => {
  const statusCreateQuote = useSelector(selectStatusCreateQuote);
  const errorCreateQuote = useSelector(selectErrorCreateQuote);

  const statusCreatePaymentAddress = useSelector(selectStatusCreatePaymentAddress);
  const errorCreatePaymentAddress = useSelector(selectErrorCreatePaymentAddress);

  const statusGetMarketPrice = useSelector(selectStatusGetMarketPrice);
  const errorGetMarketPrice = useSelector(selectErrorGetMarketPrice);

  const autoClose = 5000;

  /**
   * useEffect show error for get quote
   */
  useEffect(() => {
    if (statusCreateQuote === ERequestStatus.failed) {
      toast.error(errorCreateQuote, { autoClose, theme: 'colored' });
    }
  }, [statusCreateQuote]);

  /**
   * useEffect show error for create payment address
   */
  useEffect(() => {
    if (statusCreatePaymentAddress === ERequestStatus.failed) {
      toast.error(errorCreatePaymentAddress, { autoClose, theme: 'colored' });
    }
  }, [statusCreatePaymentAddress]);

  /**
   * useEffect show error for create payment address
   */
  useEffect(() => {
    if (statusGetMarketPrice === ERequestStatus.failed) {
      toast.error(errorGetMarketPrice, { autoClose, theme: 'colored' });
    }
  }, [statusGetMarketPrice]);
};

export { useErrors };
